import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesNominas() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "", items: [
      { label: "Colaboradores", icon: "fas fa-address-card", color: "#0d9488", href: "/Empleados", enabled: !!(user.menu_nominas && user.menu_empleados) },
      { label: "Puestos", icon: "fas fa-address-book", color: "#0d9488", href: "/Puestos", enabled: !!(user.menu_nominas && user.menu_puestos) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Colaboradores"
      descripcion="Colaboradores y puestos"
      icono="fas fa-address-card"
      color="#0d9488"
      secciones={secciones}
    />
  );
}

export default BotonesNominas;
